import ProductGroupController from './product-group-controller'

export default ProductGroupController
